import React, { Component, Fragment } from "react";
import { getAllowedSwitches } from "../../../../AssetTypeConfig/Reports/SwitchinspectionReport";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";
import { SFRTA_DefectDetectorTestsAndInspectionsReportContents } from "./SFRTA_DefectDetectorTestsAndInspectionsReportSchema";

const {
  TrackSection,
  DraggingEquipmentTitle,
  HBDTitle,
  _30d,
  _90d,
  TestCasesTable,
  rowDataSequence
} = SFRTA_DefectDetectorTestsAndInspectionsReportContents;

const ReportView = (props) => {
  let { data } = props;
  let tracks = Array.isArray(data.tracks) ? data.tracks : [];
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Inspection Report - Defect Detector Tests & Inspections" {...props} fontSizeOverride={'35px'} />
      <span className="spacer"></span>
      <ReportFraInfoSectionContainer {...props} />
      <span className="spacer"></span>

      {tracks.map((track, i) => {
        const { sfrtaDraggingEquip30Days, sfrtaHotBox30Days, sfrtaHotBox90Days } = track.values;
        return <table className="table-bordered" style={{ fontSize: '20px' }} key={i}>
          <ReportTableSectionRenderer section={TrackSection} rowsData={{ track: track.track }} />
          {sfrtaDraggingEquip30Days ?
            <Fragment>
              <ReportTableSectionRenderer section={DraggingEquipmentTitle} />
              <ReportTableSectionRenderer section={_30d} />
              <ReportTableSectionRenderer section={TestCasesTable} rowsData={sfrtaDraggingEquip30Days} />
            </Fragment>
            : null
          }

          {sfrtaHotBox30Days || sfrtaHotBox90Days ?
            <ReportTableSectionRenderer section={HBDTitle} />
            : null
          }

          {sfrtaHotBox30Days ?
            <Fragment>
              <ReportTableSectionRenderer section={_30d} />
              <ReportTableSectionRenderer section={TestCasesTable} rowsData={sfrtaHotBox30Days} />
            </Fragment>
            : null
          }

          {sfrtaHotBox90Days ?
            <Fragment>
              <ReportTableSectionRenderer section={_90d} />
              <ReportTableSectionRenderer section={TestCasesTable} rowsData={sfrtaHotBox90Days} />
            </Fragment>
            : null
          }

        </table>
      })}
    </div>
  );
};

const SFRTA_DefectDetectorTestsAndInspectionsReport = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ReportView
      data={{
        tracks: [
          {
            track: '<Track Name>',
            values:
            {
              sfrtaDraggingEquip30Days: [],
              sfrtaHotBox30Days: [],
              sfrtaHotBox90Days: [],
            }
          }
        ]
      }}
    />
  }

  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let reportGroups = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [
    'sfrtaDraggingEquip30Days',
    'sfrtaHotBox30Days',
    'sfrtaHotBox90Days'
  ]);
  let reportsWithDecodedFormData = ReportGroupingUtils.decodeTestsInReportGroups(reportGroups, true);

  reportsWithDecodedFormData = reportsWithDecodedFormData.map(report => {
    let tracks = {};
    report.decodedData.forEach(d => {
      let targetTables = ['Hot Box Detector', 'Dragging Equipment'];
      targetTables.forEach(tableKey => {
        d.summary && d.summary[tableKey] && d.summary[tableKey].forEach(row => {
          if (!tracks[row['Track']]) { tracks[row['Track']] = { track: row['Track'], values: {} }; }
          if (!tracks[row['Track']].values[d.testCode]) { tracks[row['Track']].values[d.testCode] = {} }
          tracks[row['Track']].values[d.testCode] = rowDataSequence[d.testCode].map(value => ({ description: value, status: row[value] }));
        })
      })
    })
    return { tracks: Object.keys(tracks).map(key => tracks[key]), ...report };
  })

  return reportsWithDecodedFormData.map((report, i) => <ReportView
    key={i}
    {...props}
    data={report}
  />)
}

export default SFRTA_DefectDetectorTestsAndInspectionsReport;



// WEBPACK FOOTER //
// ./src/components/Reports/SFRTA/DefectDetectorTestsAndInspectionsReport/index.jsx